import { useCallback } from 'react';

import resumeCardSuitableRemoveButtonClick from '@hh.ru/analytics-js-events/build/xhh/employer/responses/resume_card/resume_card_suitable_remove_button_click';
import { Button } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import defaultRequestErrorHandler from 'src/api/notifications/defaultRequestErrorHandler';
import { useNotification } from 'src/components/Notifications/Provider';
import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import { EmployerStateExtName } from 'src/models/negotiationTopic.types';
import fetcher from 'src/utils/fetcher';

const TrlKeys = {
    text: 'employer.vacancyResponses.hideSuitableApplicant',
};

const HIDE_SUITABLE_URL = '/shards/employer/hide_suitable';

interface HideSuitableParams {
    vacancyId: number;
    resumeId: string;
}

declare global {
    interface FetcherPostApi {
        [HIDE_SUITABLE_URL]: {
            queryParams: HideSuitableParams;
            body: null;
            response: void;
        };
    }
}

interface Props {
    isMobile?: boolean;
    resumeId: string;
    setHidden: (state: boolean) => void;
    vacancyId: number;
}

const RemoveFromSuitableButton: TranslatedComponent<Props> = ({ isMobile, resumeId, setHidden, trls, vacancyId }) => {
    const { addNotification } = useNotification();
    const collection = useSelector((state) => state.candidatesList?.collection?.name);

    const sendAnalytics = useCallback(() => {
        if (collection) {
            resumeCardSuitableRemoveButtonClick({
                vacancyId,
                folderName: collection as unknown as EmployerStateExtName,
            });
        }
    }, [collection, vacancyId]);

    const clickHandler = useCallback(async () => {
        sendAnalytics();
        try {
            await fetcher.post(HIDE_SUITABLE_URL, null, { params: { vacancyId, resumeId } });
            setHidden(true);
        } catch (error) {
            defaultRequestErrorHandler(error, addNotification);
        }
    }, [addNotification, resumeId, sendAnalytics, setHidden, vacancyId]);

    return (
        <Button
            stretched={isMobile}
            size="small"
            mode="secondary"
            onClick={clickHandler}
            data-qa="resume-card-action resume-card-action_remove-from-suitable"
        >
            {trls[TrlKeys.text]}
        </Button>
    );
};

export default translation(RemoveFromSuitableButton);
